// Vocabulário de situação do alvará.
//
// Separado do componente porque um arquivo que exporta componente e constante
// quebra o Fast Refresh do Vite — a mesma razão que separou `shared-data.ts` de
// `shared.tsx` no dashboard.

import type { SituacaoAlvara } from '@/lib/condominioRepo';

export const ROTULO_SITUACAO: Record<SituacaoAlvara, string> = {
  vigente: 'Vigente',
  a_vencer: 'A vencer',
  vencido: 'Vencido',
  pendente: 'Não registrado',
  nao_se_aplica: 'Não se aplica',
};

export const CLASSE_SITUACAO: Record<SituacaoAlvara, string> = {
  vigente: 'bg-green-50 text-green-700 border-green-200',
  a_vencer: 'bg-amber-50 text-amber-700 border-amber-200',
  vencido: 'bg-red-50 text-red-700 border-red-200',
  pendente: 'bg-background-100 text-foreground-600 border-background-300',
  nao_se_aplica: 'bg-background-100 text-foreground-500 border-background-300',
};
